import { isSourcingActive, type SourcingRun } from "@vidario/domain";
import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { useVidarioClient } from "../client";
import { queryKeys } from "../queryKeys";

/** Polls a job's latest sourcing run every 3s while the pipeline is
 * active, and stops once it reaches a terminal status. Returns `null`
 * when no run exists yet. */
export function useSourcingRun(
  jobId: string,
  options?: { enabled?: boolean },
): UseQueryResult<SourcingRun | null> {
  const client = useVidarioClient();
  return useQuery({
    queryKey: queryKeys.sourcingRun(jobId),
    queryFn: () => client.getSourcingRun(jobId),
    enabled: (options?.enabled ?? true) && Boolean(jobId),
    refetchInterval: (query) => {
      const run = query.state.data;
      return run && isSourcingActive(run.status) ? 3000 : false;
    },
  });
}
